import { useIsMobile } from '@/shared/utils'
import { Link } from 'react-router-dom'
import DisputIcon from '@/shared/assets/icons/dashboard/orders.svg?react'
import { ChevronRight } from 'lucide-react'
import { DisputModel, DisputStatusIcons, DisputStatusTitles } from '@/features/orders'
import { ItemLayout, OrderIcon } from '@/shared/components'
import { formatDate } from '@/shared/lib'

export const DisputLink = ({
  disputData,
  disputId,
}: {
  disputId: string
  disputData: DisputModel
}) => {
  const isMobile = useIsMobile()
  const disputTitle = disputData ? DisputStatusTitles[disputData.status] : ''

  return (
    <>
      {isMobile && (
        <Link to={`/orders/${disputId}`}>
          <div className="flex justify-between items-center bg-light-purple dark:bg-dark-purple px-4 py-2 rounded-lg w-full text-primary">
            <div className="flex items-center gap-2">
              <DisputIcon className="w-[18px] h-[18px]" />
              <span className="font-medium text-sm">{disputTitle}</span>
            </div>
            <ChevronRight />
          </div>
        </Link>
      )}
      {!isMobile && (
        <div className="flex items-center gap-2">
          <ItemLayout
            title={DisputStatusTitles[disputData.status]}
            subtitle={formatDate(disputData.createdAt, 'long', {})}
            icon={
              <OrderIcon
                status={DisputStatusIcons[disputData.status]}
                className={'w-[40px] h-[40px]'}
              />
            }
            titleClasses="text-sm font-medium"
          />
          <Link to={`/orders/${disputId}`}>
            <ChevronRight className="text-primary" />
          </Link>
        </div>
      )}
    </>
  )
}
